import { FormlyFieldConfig } from "@ngx-formly/core";
import { FieldDefinitionConditions } from "../../../../../../sections/medicinalProduct/message/fieldDefinition-conditions";
import { FieldDefinitionFields } from "../../../../../../sections/medicinalProduct/message/fieldDefinition-fields";
import { Injector } from "@angular/core";
import { EntityEnum } from "../../../EntityEnum";
import { MedicinalProductsQueryNode } from "../../MedicinalProductsQueryNode";
import { Art57Section } from "../../../../Art57Section/Art57Section";
import { AutoUploadEntityEnum as AutoUploadEntityEnum } from "../../../../AutoUploadEntityEnum";
import { TreeNodeMedicinalProductsAbstractCompositions } from "../../ListEntity/TreeNodeMedicinalProductsAbstractCompositions";

export class AbstractCompositionQueryNode extends MedicinalProductsQueryNode {
    constructor(injector: Injector) {
    const queryFields: FormlyFieldConfig[] =  new FieldDefinitionFields(injector).abstractCompositionFields;
    const createChidTemplateParams = {};
    const queryConditions: FormlyFieldConfig[] = new FieldDefinitionConditions(injector).abstractCompositionsConditions;
       super(injector, [], 'Abstract Compositions', EntityEnum.abstractCompositionsSearch,  queryFields, queryConditions, injector.get(Art57Section).medicinalProduct.abstractCompositionsTreeNode,TreeNodeMedicinalProductsAbstractCompositions,AutoUploadEntityEnum.abstractCompositions,createChidTemplateParams);
       
    }
}